import React from 'react'
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form'

import { formatPrice, unformat } from '../utils/pricing'

import StyledInput from './StyledInput'
import ErrorMessage from './ErrorMessage'
import { Label } from './Field'

type CurrencyFieldProps = {
  name: string
  label?: string
  precision?: 0 | 2
  placeholder?: string
  validationRules?: RegisterOptions
  formatValue?: (value: number, precision?: number) => string
  skipErrorMessage?: boolean
  'aria-label'?: string
  onClick?: () => any
  setInputRef?: (e: HTMLInputElement) => any
}

const CurrencyField = ({
  name,
  label,
  precision = 0,
  placeholder = '$',
  validationRules,
  formatValue = formatPrice,
  skipErrorMessage = false,
  'aria-label': ariaLabel,
  onClick,
  setInputRef,
}: CurrencyFieldProps) => {
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      rules={validationRules}
      render={({ field: { onChange, value, ref, ...field } }) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          const nextValue = unformat(e.target.value)
          return onChange(nextValue)
        }

        const formattedValue = formatValue(value, precision) || ''

        return (
          <>
            <StyledInput
              {...field}
              type="text"
              aria-label={ariaLabel}
              onChange={handleChange}
              value={formattedValue}
              placeholder={placeholder}
              ref={(e: HTMLInputElement) => {
                ref(e)
                if (setInputRef) {
                  setInputRef(e)
                }
              }}
              onClick={onClick}
            />
            {label && <Label htmlFor={name}>{label}</Label>}
            {!skipErrorMessage && <ErrorMessage name={name} />}
          </>
        )
      }}
    />
  )
}

export default CurrencyField
